import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceCustomFieldProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-custom-field-project-limit',
	path: '/jira/settings/system/performance/metrics/customfield/projectlimit',
};
